import React, { useContext, useEffect } from "react";
import globalContext from "../Context/GlobalContext";

export default function Channels() {
  const contextData = useContext(globalContext);
  useEffect(() => {
    contextData.setIsHeaderShown(true);
  }, []);

  const SOCIAL_MEDIA1 = [
    {
      id: 1,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_281_19)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.7651 0H27.2476C29.869 0 32.0127 2.14366 32.0127 4.76513C32.0127 45.1073 32.0127 -4.37772 32.0127 27.2478C32.0127 29.8693 29.869 32.0129 27.2476 32.0129H4.7651C2.14365 32.0129 0 29.8693 0 27.2478V4.76513C0 2.14366 2.14365 0 4.7651 0Z"
              fill="transparent"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.9994 13.4559C30.579 14.4245 29.5717 15.4188 28.3837 16.6843C26.8082 18.3631 25.2198 19.9128 24.4063 20.5584C22.663 21.966 21.0617 22.7538 19.4346 23.0379C18.5952 23.1799 17.1876 23.1283 16.3611 22.9087C15.6251 22.715 15.6767 22.6892 15.3926 23.5286C15.1602 24.2001 15.0181 24.8845 14.9665 25.5948L14.9277 26.1371L14.734 26.0984C13.1198 25.7755 11.5057 24.3809 10.8858 22.7667C10.6792 22.2501 10.563 21.6948 10.5371 21.1396L10.5113 20.6876L10.0981 20.3131C9.24579 19.5253 8.67759 18.5697 8.50971 17.5625C8.22562 15.9741 8.96169 14.1791 10.563 12.552C12.2546 10.8474 14.734 9.50437 17.1618 8.97491C18.0399 8.79412 19.5895 8.74246 20.3643 8.8716C21.8881 9.12987 23.1149 9.90469 23.8897 11.054C24.1351 11.4156 24.148 11.4672 24.1222 11.7901C24.1222 12.0354 24.0318 12.2679 23.8768 12.4487C23.257 13.3139 21.4103 14.2437 19.4346 14.6827C15.935 15.4576 13.7139 14.489 14.0625 12.3325C14.1013 12.1129 14.1142 11.9321 14.1013 11.9192C14.0625 11.8805 13.7139 12.0613 13.3394 12.3195C12.7066 12.7586 12.1384 13.6367 11.9447 14.4632C11.8931 14.6698 11.8801 15.0056 11.8931 15.3284C11.9189 15.7675 11.9576 15.9354 12.1513 16.3099C12.2805 16.5552 12.5129 16.9039 12.6937 17.0976L13.0165 17.4333L12.8874 17.6012C12.5129 18.0919 12.203 18.6472 11.9835 19.2283C11.8285 19.7061 11.751 20.2098 11.751 20.7134C11.751 21.0233 11.7768 21.3462 11.8414 21.6561C11.9835 22.276 12.3967 23.1153 12.8228 23.619C13.1457 23.9935 13.8817 24.6392 13.998 24.6392C14.0238 24.6392 14.0625 24.5746 14.0625 24.4971C14.0625 24.1872 14.3079 23.2057 14.5016 22.7279C15.0698 21.3203 16.2966 20.1194 18.2594 19.0734C18.5823 18.9055 19.525 18.4406 20.3514 18.0661C22.1593 17.2267 23.1537 16.7102 23.696 16.3228C25.2586 15.2122 26.2271 13.5722 26.5499 11.4931C26.6662 10.7312 26.6662 9.31066 26.5499 8.54876C26.0592 5.29452 23.6186 3.08629 20.1319 2.72471C16.232 2.31147 11.2732 5.33326 8.2127 9.95634C6.72765 12.2162 5.72039 14.7086 5.29424 17.2138C5.12637 18.1823 5.07471 19.9902 5.16511 20.8813C5.42338 23.1541 6.26276 24.9878 7.69616 26.4212C8.41932 27.1444 9.2587 27.7384 10.1885 28.1775C13.3523 29.6884 16.8389 29.7142 19.9124 28.2679C21.2425 27.648 22.5467 26.6795 23.9414 25.2719C25.2973 23.9031 26.2271 22.7667 28.7323 19.3316C29.4813 18.3115 30.8501 16.3873 31.9607 15.7417V13.4689L31.9994 13.4559Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_281_19">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      title: "ایتا",
      link: "https://eitaa.com/ScarpinChannel",
      isEnable: true,
    },
    {
      id: 2,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.4735 5.4785C17.4655 5.4785 17.4655 5.4785 17.4575 5.4785C17.2978 5.45455 17.1381 5.43857 16.9783 5.4226C16.9224 5.41462 16.8665 5.41462 16.8106 5.40663C16.6908 5.39864 16.579 5.39066 16.4593 5.38267C16.3794 5.38267 16.2915 5.37469 16.2117 5.37469C16.1398 5.37469 16.0759 5.3667 16.0041 5.3667C15.9721 5.3667 15.9402 5.3667 15.9082 5.3667C15.8843 5.3667 15.8683 5.3667 15.8443 5.3667C15.7964 5.3667 15.7485 5.3667 15.7006 5.37469C15.6287 5.37469 15.5648 5.37469 15.4929 5.38267C15.4211 5.38267 15.3492 5.39066 15.2693 5.39864C15.2054 5.40663 15.1336 5.40663 15.0697 5.41462C14.9978 5.4226 14.9259 5.43059 14.8541 5.43857C14.7902 5.44656 14.7183 5.45455 14.6544 5.46253C14.5825 5.47052 14.5107 5.48649 14.4388 5.49448C14.3749 5.50246 14.311 5.51045 14.2391 5.52642C14.1673 5.54239 14.0954 5.55038 14.0235 5.56635C13.9596 5.57434 13.8957 5.59031 13.8319 5.60628C13.76 5.62225 13.6881 5.63822 13.6162 5.6542C13.5523 5.67017 13.4885 5.68614 13.4246 5.70211C13.3527 5.71808 13.2808 5.74204 13.2169 5.75801C13.153 5.77399 13.0892 5.78996 13.0333 5.80593C12.9614 5.82989 12.8975 5.84586 12.8256 5.86982C12.7697 5.88579 12.7058 5.90975 12.6419 5.92572C12.5701 5.94968 12.5062 5.97364 12.4343 5.9976C12.3784 6.02155 12.3145 6.03753 12.2586 6.06148C12.1867 6.08544 12.1228 6.11739 12.059 6.14134C12.0031 6.1653 11.9472 6.18926 11.8833 6.21322C11.8114 6.24516 11.7475 6.26912 11.6836 6.30106C11.6277 6.32502 11.5718 6.34898 11.5159 6.37294C11.452 6.40488 11.3801 6.43683 11.3163 6.46877C11.2604 6.49273 11.2045 6.52467 11.1565 6.54863C11.0926 6.58057 11.0208 6.62051 10.9569 6.65245C10.909 6.68439 10.8531 6.70835 10.8051 6.73231C10.7333 6.77224 10.6694 6.81217 10.6055 6.8521C10.5576 6.88404 10.5097 6.908 10.4618 6.93995C10.3899 6.98786 10.318 7.02779 10.2461 7.07571C10.2062 7.09967 9.79092 7.37918 9.79092 7.37918C9.79092 7.37918 7.85831 5.90176 7.08366 5.50246C6.30902 5.10316 5.39062 5.66218 5.39062 6.53266V15.9961C5.39062 21.6262 9.77495 26.2342 15.3173 26.5936C15.3492 26.5936 15.3811 26.6015 15.4131 26.6015C15.5169 26.6095 15.6287 26.6095 15.7325 26.6095C15.7964 26.6095 15.8683 26.6175 15.9322 26.6175H15.9721C15.9881 26.6175 16.0041 26.6175 16.012 26.6175C16.0919 26.6175 16.1718 26.6095 16.2516 26.6095C16.3395 26.6095 16.4273 26.6095 16.5231 26.6015C16.611 26.5936 16.7068 26.5936 16.8027 26.5856C16.8985 26.5776 16.9783 26.5776 17.0662 26.5616C17.162 26.5536 17.2499 26.5377 17.3377 26.5297C17.4256 26.5217 17.5134 26.5057 17.6013 26.4977C17.6891 26.4817 17.7769 26.4658 17.8728 26.4498C17.9606 26.4338 18.0405 26.4179 18.1283 26.4019C18.2162 26.3859 18.304 26.362 18.3919 26.346C18.4797 26.322 18.5596 26.3061 18.6394 26.2901C18.7273 26.2661 18.8151 26.2422 18.903 26.2182C18.9908 26.1943 19.0707 26.1703 19.1505 26.1463C19.2384 26.1224 19.3183 26.0904 19.4061 26.0585C19.486 26.0345 19.5658 26.0026 19.6457 25.9786C19.7255 25.9467 19.8134 25.9147 19.8932 25.8828C19.9731 25.8509 20.053 25.8269 20.1328 25.787C20.2127 25.755 20.2925 25.7151 20.3724 25.6752C20.4523 25.6352 20.5241 25.6113 20.604 25.5713C20.6759 25.5314 20.7637 25.4915 20.8436 25.4516C20.9234 25.4116 20.9953 25.3797 21.0672 25.3397C21.1391 25.2998 21.2189 25.2519 21.2908 25.212C21.3627 25.172 21.4345 25.1321 21.5064 25.0842C21.5783 25.0443 21.6582 24.9884 21.73 24.9404C21.8019 24.8925 21.8738 24.8526 21.9377 24.8047C22.0095 24.7568 22.0814 24.7009 22.1533 24.6529C22.2252 24.605 22.2891 24.5571 22.3609 24.5092C22.4248 24.4613 22.4967 24.4054 22.5686 24.3495C22.6404 24.2936 22.6963 24.2457 22.7602 24.1977C22.8241 24.1418 22.896 24.0859 22.9599 24.0221C23.0238 23.9661 23.0877 23.9182 23.1436 23.8623C23.2074 23.8064 23.2713 23.7425 23.3352 23.6787C23.3911 23.6228 23.455 23.5668 23.5109 23.5109C23.5748 23.4471 23.6307 23.3832 23.6946 23.3193C23.7505 23.2634 23.8064 23.1995 23.8623 23.1436C23.9182 23.0797 23.9821 23.0078 24.038 22.9439C24.0939 22.8801 24.1498 22.8241 24.1977 22.7603C24.2536 22.6884 24.3095 22.6245 24.3654 22.5526C24.4213 22.4807 24.4692 22.4248 24.5172 22.361C24.5731 22.2891 24.621 22.2172 24.6689 22.1453C24.7168 22.0735 24.7647 22.0096 24.8126 21.9457C24.8606 21.8738 24.9085 21.794 24.9564 21.7221C25.0043 21.6502 25.0442 21.5863 25.0921 21.5144C25.1401 21.4426 25.18 21.3627 25.2279 21.2828C25.2678 21.211 25.3158 21.1391 25.3557 21.0672C25.3956 20.9874 25.4355 20.9075 25.4755 20.8276C25.5154 20.7558 25.5553 20.6839 25.5873 20.612C25.6272 20.5322 25.6671 20.4443 25.6991 20.3645C25.731 20.2926 25.771 20.2207 25.7949 20.1408C25.8348 20.053 25.8668 19.9652 25.8987 19.8853C25.9307 19.8134 25.9546 19.7336 25.9866 19.6617C26.0185 19.5738 26.0425 19.486 26.0744 19.3981C26.0984 19.3183 26.1303 19.2464 26.1543 19.1745C26.1862 19.0867 26.2102 18.9909 26.2341 18.895C26.2581 18.8152 26.2821 18.7433 26.298 18.6634C26.322 18.5676 26.346 18.4718 26.3619 18.3759C26.3779 18.2961 26.4019 18.2242 26.4178 18.1443C26.4418 18.0485 26.4498 17.9447 26.4737 17.8489C26.4897 17.769 26.5057 17.6971 26.5137 17.6252C26.5296 17.5214 26.5376 17.4176 26.5536 17.3138C26.5616 17.2419 26.5775 17.17 26.5775 17.0982C26.5935 16.9784 26.5935 16.8586 26.6015 16.7388C26.6095 16.6829 26.6095 16.619 26.6175 16.5551C26.6255 16.3794 26.6334 16.2117 26.6334 16.036C26.6334 16.028 26.6334 16.0201 26.6334 16.0041C26.6334 10.6375 22.6564 6.19725 17.4815 5.48649L17.4735 5.4785ZM22.2092 14.6385L16.036 20.8117C15.6447 21.203 15.1176 21.4186 14.5666 21.4186C14.0155 21.4186 13.4885 21.203 13.0971 20.8117L9.79092 17.5055C9.4076 17.1141 9.19996 16.595 9.19996 16.052C9.19996 14.91 10.1263 13.9756 11.2763 13.9756C11.8194 13.9756 12.3385 14.1913 12.7298 14.5666L14.5666 16.4034L19.2703 11.6996C19.6617 11.3003 20.1967 11.0767 20.7477 11.0767C21.8898 11.0767 22.8241 12.0031 22.8241 13.1531C22.8241 13.7121 22.6005 14.2472 22.2012 14.6305L22.2092 14.6385Z"
            fill="black"
          />
        </svg>
      ),
      title: "بله",
      link: "https://ble.ir/scarpin",
      isEnable: true,
    },
    {
      id: 3,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_286_118)">
            <path
              d="M15.9275 3.50907H16.0142C16.043 5.47297 15.9997 9.41521 15.9997 9.41521C14.1225 8.36105 12.2308 7.33578 10.3535 6.26719C11.581 5.57405 12.8228 4.86647 14.0503 4.17333C14.6279 3.8412 15.2633 3.56683 15.942 3.49463L15.9275 3.50907Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M15.9991 3.50928H16.1435C16.88 3.58148 17.5298 3.92805 18.1652 4.27462C19.3349 4.93888 20.5045 5.60314 21.6742 6.2674C19.7825 7.30711 17.8764 8.3757 15.9991 9.41541C15.9847 7.45152 16.028 5.47318 15.9991 3.50928Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M10.3382 6.28174L15.9845 9.42975L10.2949 12.7511C10.2949 12.7511 10.2949 10.6427 10.2949 9.5886C10.2949 8.49112 10.3238 6.28174 10.3238 6.28174H10.3382Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M21.6895 6.28153C21.6895 8.24543 21.6895 10.1949 21.6895 12.1588C21.6895 12.3465 21.6895 12.7508 21.6895 12.7508L16 9.42954C16 9.42954 19.7978 7.32124 21.6895 6.28153Z"
              fill="black"
            />
            <path
              d="M21.6751 6.26709L21.6895 6.28153M21.6895 6.28153C21.6895 8.24543 21.6895 10.1949 21.6895 12.1588C21.6895 12.3465 21.6895 12.7508 21.6895 12.7508L16 9.42954C16 9.42954 19.7978 7.32124 21.6895 6.28153Z"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M21.6895 6.28174C22.9458 6.98932 24.1876 7.72578 25.444 8.4478C26.0505 8.77993 26.6858 9.15538 27.018 9.8052C25.2562 10.7872 21.6895 12.7511 21.6895 12.7511C21.6895 12.7511 21.6895 12.3612 21.6895 12.159C21.6895 10.1951 21.6895 8.24564 21.6895 6.28174Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M6.74262 8.34672C7.92673 7.65358 10.3383 6.28174 10.3383 6.28174L10.3094 12.7511C10.3094 12.7511 6.7715 10.8016 5.00977 9.81965C5.39966 9.14094 6.0928 8.72217 6.74262 8.34672Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M4.60553 12.3897C4.60553 11.5233 4.59109 10.5991 5.00986 9.81934C6.77159 10.8013 10.3095 12.7507 10.3095 12.7507C8.40336 13.8482 6.51167 14.9746 4.60553 16.072C4.60553 14.8446 4.60553 13.6316 4.60553 12.4042V12.3897Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M27.018 9.80518C27.3645 10.455 27.4223 11.2059 27.3934 11.9279V16.0723L21.6895 12.751C21.6895 12.751 25.2418 10.7871 27.0035 9.80518H27.018Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M4.60547 16.0576C6.51161 14.9602 8.4033 13.8338 10.3094 12.7363C10.3094 14.888 10.3094 17.054 10.3094 19.2056C10.0206 19.0901 9.74626 18.9168 9.4719 18.758C7.85457 17.8627 6.23724 16.9529 4.60547 16.0721V16.0576Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M21.6895 12.751L27.3934 16.0723C25.5017 17.1264 21.6895 19.2347 21.6895 19.2347C21.7039 18.3972 21.6895 17.5596 21.6895 16.7221V12.751Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M4.60547 16.0723C6.23724 16.9531 7.84013 17.8629 9.4719 18.7582C9.74626 18.9026 10.0206 19.0759 10.3094 19.2058V19.2203C8.56215 20.2456 6.81486 21.2564 5.06756 22.2817C4.87984 22.0073 4.79319 21.6752 4.72099 21.343C4.60547 20.7943 4.60547 20.2456 4.60547 19.6968V16.0723Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M27.3927 16.0721C27.3927 17.3428 27.3927 18.6136 27.3927 19.8843C27.4071 20.693 27.3927 21.5739 26.9594 22.2814C25.3854 21.3573 21.7031 19.2201 21.7031 19.2201C21.7031 19.2201 25.5154 17.1118 27.4071 16.0576L27.3927 16.0721Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M5.06836 22.2816C6.81565 21.2563 8.56294 20.2455 10.3102 19.2202C10.2958 21.3718 10.3102 23.5235 10.2958 25.6895C9.05392 24.9964 7.82648 24.2888 6.59905 23.5812C6.02143 23.2347 5.42937 22.8592 5.06836 22.2816Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M10.3086 19.2205C12.2147 20.2746 14.092 21.3288 15.9981 22.3685C14.1064 23.466 10.3086 25.6754 10.3086 25.6754C10.323 23.5237 10.3086 21.3721 10.323 19.2061L10.3086 19.2205Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M21.6751 19.2347H21.6895C21.6895 21.3863 21.6751 23.5379 21.704 25.704H21.6895C20.1877 24.8087 18.6715 23.9422 17.1552 23.0469C16.7798 22.8303 16 22.3682 16 22.3682C16 22.3682 19.7978 20.2599 21.6895 19.2202L21.6751 19.2347Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M21.6883 19.2347C21.8616 19.3502 25.3706 21.3863 26.9446 22.296C26.728 22.6715 26.367 22.9603 26.006 23.2058C25.4283 23.5957 24.8218 23.9134 24.2153 24.2599C23.3778 24.7365 22.5403 25.2274 21.6883 25.6895C21.6738 23.5379 21.6883 21.3863 21.6738 19.2202L21.6883 19.2347Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M15.9981 22.3682V28.4765C15.5216 28.4043 15.0162 28.3032 14.5974 28.0577C13.1678 27.2635 11.7382 26.4692 10.3086 25.675C12.2003 24.5776 14.1064 23.4656 15.9981 22.3682Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M16 22.3682C16 22.3682 16.7798 22.8303 17.1552 23.0469C18.6715 23.9277 20.1877 24.8086 21.6895 25.7039C20.2166 26.5126 18.7581 27.3212 17.2996 28.1443C16.9386 28.3465 16.5343 28.462 16.1155 28.4909H16.0144V22.3826L16 22.3682Z"
              fill="black"
              stroke="#474747"
              stroke-width="0.678006"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_286_118">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      title: "روبیکا",
      link: "https://rubika.ir/scarpinChannel",
      isEnable: true,
    },
    {
      id: 4,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.93024 17.7754L4.39707 19.7672C3.88403 21.7087 5.04089 23.6905 6.97236 24.2036L9.04467 24.7568C6.89188 23.0668 5.38293 20.6022 4.93024 17.7754Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.0188 7.79626L22.7051 7.18262C24.9987 8.95313 26.5881 11.5988 26.9603 14.6268L27.5941 12.2326C28.1072 10.2911 26.9503 8.30931 25.0188 7.79626Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.5547 27.0105L19.7678 27.594C21.7094 28.1071 23.6911 26.9502 24.2042 25.0187L24.8279 22.6748C23.1077 24.9684 20.5223 26.5679 17.5547 27.0105Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9943 5.83447C10.381 5.83447 5.83398 10.3815 5.83398 15.9948C5.83398 21.6081 10.381 26.1551 15.9943 26.1551C21.6076 26.1551 26.1546 21.6081 26.1546 15.9948C26.1546 10.3815 21.6076 5.83447 15.9943 5.83447Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.2401 10.9047C10.5419 9.32528 12.061 8.29919 13.6403 8.60098C15.2197 8.90277 16.2458 10.4318 15.944 12.0012C15.6422 13.5805 14.1232 14.6066 12.5438 14.3048C10.9644 14.0031 9.93835 12.484 10.2401 10.9047Z"
            fill="#FEC42B"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.4655 19.6867C14.1637 21.2661 12.6447 22.2922 11.0653 21.9904C9.48592 21.6886 8.45983 20.1696 8.76162 18.5902C9.06342 17.0108 10.5824 15.9847 12.1618 16.2865C13.7412 16.5883 14.7673 18.1073 14.4655 19.6867Z"
            fill="#FEC42B"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.7029 17.3432C14.9987 17.2124 14.546 16.5283 14.6768 15.8342C14.8075 15.13 15.4916 14.6773 16.1857 14.8081C16.8899 14.9389 17.3426 15.623 17.2118 16.3171C17.081 17.0213 16.397 17.4739 15.7029 17.3432Z"
            fill="#FEC42B"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.7585 21.0954C21.4567 22.6748 19.9376 23.7009 18.3583 23.3991C16.7789 23.0973 15.7528 21.5783 16.0546 19.9989C16.3564 18.4195 17.8754 17.3934 19.4548 17.6952C21.0342 17.997 22.0603 19.516 21.7585 21.0954Z"
            fill="#FEC42B"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.8387 15.7135C18.2594 15.4117 17.2333 13.8927 17.5351 12.3133C17.8369 10.734 19.3559 9.70788 20.9352 10.0097C22.5146 10.3115 23.5407 11.8305 23.2389 13.4099C22.9371 14.9892 21.4181 16.0153 19.8387 15.7135Z"
            fill="#FEC42B"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.3963 4.97975L12.2335 4.40635C10.2919 3.8933 8.31018 5.05017 7.79713 6.98164L7.25391 9.01371C8.99424 6.86092 11.5192 5.37208 14.3963 4.97975Z"
            fill="black"
          />
        </svg>
      ),
      title: "آپارات",
      link: "https://www.aparat.com/ScarpinChannel",
      isEnable: true,
    },
  ];
  const SOCIAL_MEDIA2 = [
    {
      id: 1,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_282_45)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.1083 5.41162H20.8828C24.0201 5.41162 26.6083 7.99986 26.6083 11.1371V20.8626C26.6083 23.9999 24.0201 26.5881 20.8828 26.5881H11.1083C7.97105 26.5881 5.38281 23.9999 5.38281 20.8626V11.1371C5.38281 7.99986 7.97105 5.41162 11.1083 5.41162Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.6962 9.10791C22.353 9.10791 22.9118 9.66673 22.9118 10.3236C22.9118 10.9805 22.353 11.5393 21.6962 11.5393C20.9903 11.5393 20.4805 10.9805 20.4805 10.3236C20.4805 9.66673 20.9903 9.10791 21.6962 9.10791Z"
              fill="#FEC42B"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.9696 10.2256H16.0187C19.1559 10.2256 21.7932 12.8628 21.7932 16.0001C21.7932 19.1864 19.1559 21.7746 16.0187 21.7746H15.9696C12.8324 21.7746 10.2441 19.1864 10.2441 16.0001C10.2441 12.8628 12.8324 10.2256 15.9696 10.2256Z"
              fill="#FEC42B"
            />
          </g>
          <defs>
            <clipPath id="clip0_282_45">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      title: "اینستاگرام",
      link: "https://instagram.com/scarpin.ir?igshid=YmMyMTA2M2Y",
      isEnable: true,
    },
    {
      id: 2,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_281_23)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.76149 0H27.2385C29.8527 0 32 2.14734 32 4.76149V27.2385C32 29.8527 29.8527 32 27.2385 32H4.76149C2.14734 32 0 29.8527 0 27.2385V4.76149C0 2.14734 2.14734 0 4.76149 0Z"
              fill="transparent"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.15331 14.9963C11.7281 13.0823 17.2598 10.3515 22.0446 8.50756C26.4677 6.88539 26.3977 7.32886 25.7324 11.7519C25.219 15.288 24.6238 18.8358 24.0402 22.3719C23.8185 24.0641 22.9316 24.951 21.0877 23.924L15.3342 19.8628C14.5173 19.1976 14.739 18.6841 15.4042 18.0189L20.7142 13.0006C22.1146 11.6002 21.4494 11.0867 19.8273 12.1837L12.5216 17.1203C11.4947 17.8555 10.386 17.8555 9.20728 17.4937L6.69816 16.6068C5.07599 16.0116 6.32471 15.358 7.14163 14.9846L7.15331 14.9963Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_281_23">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      title: "تلگرام",
      link: "https://t.me/scarpinChannel",
      isEnable: true,
    },
    {
      id: 3,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.38057 24.1661L10.8798 23.9038L11.7888 23.7445C13.0725 24.4379 14.4593 24.8127 16.0055 24.8127C20.8593 24.8127 24.8137 20.8584 24.8137 16.0045C24.8137 11.1506 20.8593 7.19629 16.0055 7.19629C11.1516 7.19629 7.19727 11.1506 7.19727 16.0045C7.19727 17.7661 7.73138 19.3685 8.58409 20.7553L8.48101 21.5518L8.26549 23.1541L8.1062 24.3816L9.38995 24.1661H9.38057Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.2663 11.1977C12.8566 10.8229 13.2315 11.0946 13.4376 11.6756L13.9717 13.0624C13.9717 13.0624 14.3465 13.812 13.3814 14.5523C13.2221 14.6554 13.2221 14.6554 13.2783 14.9271C13.4938 15.5643 14.3465 17.4946 17.0733 18.9845C17.3357 19.1438 17.3919 19.1438 17.6637 18.9283C17.8792 18.7128 18.1416 18.4504 18.3571 18.2349C18.835 17.8038 19.1067 17.6445 19.5284 17.9725C19.847 18.188 20.1656 18.4504 20.4935 18.6659C20.8121 18.9283 21.3462 19.2562 20.8121 19.8934L20.3342 20.4838C19.6408 21.3365 19.0505 21.3927 18.1416 21.1772C14.6745 20.2682 12.107 17.8132 10.9919 14.3461C10.6171 13.0155 11.1512 11.8911 12.2757 11.1977H12.2663Z"
            fill="#FEC42B"
          />
        </svg>
      ),
      title: "واتساپ",
      link: "https://whatsapp.com/channel/0029VaKomTJ8fewoWHotHe2J",
      isEnable: true,
    },
    {
      id: 4,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.94141 12.8994H10.6911V25.4713H6.94141V12.8994Z"
            fill="#1A1A1A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.79883 6.52881C10.0487 6.52881 11.0681 7.54815 11.0681 8.79805C11.0681 10.048 10.0487 11.0673 8.79883 11.0673C7.54893 11.0673 6.57812 10.048 6.57812 8.79805C6.57812 7.54815 7.54893 6.52881 8.79883 6.52881Z"
            fill="#1A1A1A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.8989 12.8996H16.6V14.6592C17.3888 13.5063 18.6751 12.7661 20.1556 12.7661H21.1749C23.5291 12.7661 25.4222 14.7077 25.4222 17.0134V25.4715H21.721V18.6759C21.6725 17.2439 20.7017 16.1275 19.2697 16.1275C17.8378 16.1275 16.6364 17.2318 16.5879 18.6759V25.4715H12.8867V12.8996H12.8989Z"
            fill="#1A1A1A"
          />
        </svg>
      ),
      title: "لینکدین",
      link: "https://www.linkedin.com/company/scarpin",
      isEnable: true,
    },
  ];
  return (
    <div
      style={{
        backgroundImage: "url('../assets/images/other/linksBackGround.png')",
      }}
      className="relative w-full h-screen bg-cover bg-no-repeat flex flex-col items-center justify-center  bg-color-primary-A "
      onScroll={(e) => {}}
    >
      <div className="w-full max-w-[1440px] h-screen flex flex-col items-center justify-center mt-[100px] min-[769px]:mt-[0px]  ">
        <div className="w-full min-[767px]:w-[700px] h-full flex flex-col items-center justify-center  ">
          <div className="w-full flex items-center justify-center ">
            <h1 className="font-font_primary_A font-semibold text-[20px] min-[769px]:text-[32px] text-color-primary-D">
              شبکه‌های اجتماعی اسکارپین
            </h1>
          </div>
          <div className="w-full flex items-center justify-center mt-[10px]">
            <h1 className="font-font_primary_A font-semibold text-[14px] min-[769px]:text-[16px] text-color-primary-D">
              ما را در شبکه‌های اجتماعی دنبال کنید
            </h1>
          </div>
          <div className="w-full max-w-[1000px] max-h-[calc(100vh-210px)]  flex items-center justify-center gap-x-[100px]  flex-wrap  overflow-auto ">
            <div
              dir="rtl"
              className="flex flex-col items-center justify-between gap-y-[18px] mt-[46px] "
            >
              {SOCIAL_MEDIA1.map((scM) => (
                <button
                  className={`w-[240px] h-[50px] flex items-center justify-start pr-[50px]  gap-x-[20px] rounded-[5px] p-[10px] hover:bg-[#f3cb5f] hover:border-[1px] hover:border-color-primary-D ${
                    scM.isEnable
                      ? "bg-color-primary-B"
                      : "bg-[#fec62b] opacity-40"
                  } `}
                  onClick={() => {
                    if (scM.link) {
                      window.open(scM.link, "_blank");
                    }
                  }}
                >
                  {scM?.svg}

                  <span className="font-font_primary_A font-medium text-[16px] text-color-primary-D">
                    {scM.title}
                  </span>
                </button>
              ))}
            </div>
            <div
              dir="rtl"
              className="flex flex-col items-center justify-between gap-y-[18px] mt-[46px]"
            >
              {SOCIAL_MEDIA2.map((scM) => (
                <button
                  className={`w-[240px] h-[50px] flex items-center justify-start pr-[50px] gap-x-[20px] rounded-[5px] p-[10px] hover:bg-[#f3cb5f] hover:border-[1px] hover:border-color-primary-D ${
                    scM.isEnable
                      ? "bg-color-primary-B"
                      : "bg-[#fec62b] opacity-40"
                  } `}
                  onClick={() => {
                    if (scM.link) {
                      window.open(scM.link, "_blank");
                    }
                  }}
                >
                  {scM?.svg}

                  <span className="font-font_primary_A font-medium text-[16px] text-color-primary-D">
                    {scM.title}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <img
        src="../assets/images/other/big_polygonL.svg"
        className="absolute hidden min-[769px]:block left-[-90px] bottom-0 w-[300px] h-[280px]"
      />
    </div>
  );
}
